module.exports = __webpack_public_path__ + "static/media/2.ecfe04d5.jpg";